export const listBottom = [
    {
        name: 'Клиент',
        description: '«Teboil»',
    },
    {
        name: 'сроки проекта',
        description: 'декабрь 2022 – март 2023',
    },
    {
        name: 'технологии',
        description: '1C-Битрикс: Управление сайтом, React JS',
    },
    {
        name: 'Отрасль',
        description: 'Нефтяная промышленность',
    },
];

export const listTeamCustomer = {
    crewList: [
        {
            crewItemTitle: 'Иван Саламатов',
            crewItemSubtitle: 'Руководитель проекта, бренд TEBOIL',
        },
    ],
};

export const listTask = [
    {
        number: '1',
        text: 'Разработать сайт интернет-магазина с лёгким и понятным интерфейсом.',
    },
    {
        number: '2',
        text: 'Автоматизировать процесс продажи продукции бренда.',
    },
    {
        number: '3',
        text: 'Интегрировать сайт с сервисами доставки и оплаты.',
    },
];

export const listDescription = [
    {
        title: 'Описание проекта',
        list: [
            {
                text: 'В&nbsp;2022 году в&nbsp;Россию пришел новый международный бренд Teboil&nbsp;&mdash; производитель и&nbsp;поставщик топлива, смазочных материалов и&nbsp;жидкостей для автомобилей. Также в&nbsp;управлении бренда сеть заправочных станций. Для взаимодействия с&nbsp;современным клиентом и&nbsp;расширения продаж компания решила запустить интернет-магазин.',
            },
            {
                text: 'Разработку этого сайта доверили нашему агентству. Команда накопила большую экспертизу в&nbsp;разработке крупных ИТ-решений для корпораций, в&nbsp;том числе для клиентов из&nbsp;сферы производства, продажи моторных масел и&nbsp;смазочным материалов.',
            },
            {
                text: 'Для клиента крайне важно в&nbsp;кратчайшие сроки запустить интернет-магазин для быстрого вывода бренда на&nbsp;российский рынок и&nbsp;старта продаж смазочных материалов.',
            },
        ],
    },
];

export const listSolution = [
    {
        number: '1.',
        text: 'Подготовка сервера, настройка ci/cd, настройка сервиса анализа ошибок sentry, подготовка тестовых и&nbsp;боевых площадок для разработки.',
    },
    {
        number: '2.',
        text: 'Создание интуитивно понятного&nbsp;UI и&nbsp;дизайн-макетов проекта.',
    },
    {
        number: '3.',
        text: 'Реализация backend и&nbsp;API интеграций.',
    },
    {
        number: '4.',
        text: 'Верстка сайта и&nbsp;синхронизация backend и&nbsp;frontend.',
    },
    {
        number: '5.',
        text: 'Настройка SEO.',
    },
    {
        number: '6.',
        text: 'Тестирование готового функционала и&nbsp;интеграция с&nbsp;внешними сервисами эквайринга, справочником адресов, фулфилмент-оператором.',
    },
    {
        number: '7.',
        text: 'Отладка проекта.',
    },
    {
        number: '8.',
        text: 'Релиз готового функционала.',
    },
];

export const listProcess = [
    {
        text: 'Реализация сайта на&nbsp;современном стеке позволяет создать высокопроизводительный, безопасный и&nbsp;современный сайт, который будет соответствовать ожиданиям пользователей и&nbsp;развиваться вместе с&nbsp;бизнес-требованиям.',
    },
    {
        text: 'В&nbsp;технологическую основу проекта заложили решение от&nbsp;&laquo;1С-Битрикс&raquo; и&nbsp;ReactJS. У&nbsp;нашей команды большой опыт по&nbsp;разработке сайтов крупным корпорациям, который доказывает, что React повышает производительность создания и&nbsp;развития проектов, а&nbsp;также снижает стоимость обслуживания сайта.',
    },
    {
        text: 'React позволяет добиваться высокой скорости работы. При этом роли фронтенд- и&nbsp;бэкенд-разработчиков разделены, а&nbsp;клиентские и&nbsp;серверные приложения взаимодействуют через Rest API.',
    },
    {
        text: 'После того, как определились со&nbsp;стеком, функциональной частью, структурой и&nbsp;архитектурой проекта, разработали прототип сайта. Он&nbsp;наглядно отображает структуру будущего проекта, визуализирует его и&nbsp;помогает внести корректировки перед разработкой дизайна.',
    },
];

export const listResult = [
    {
        description: 'добавление новых способов доставки;',
    },
    {
        description: 'добавление функционала скидок и&nbsp;акций внутри интернет-магазина;',
    },
    {
        description: 'интеграция с&nbsp;системой лояльности бренда;',
    },
    {
        description: 'внедрение фильтров для подбора масел;',
    },
    {
        description: 'реализация функционала отзывов и&nbsp;рейтинга товара;',
    },
    {
        description: 'улучшение SEO проекта.',
    },
];

export const listLayoutPage = [
    {
        name: 'Список товаров',
        image: '/images/pic/teboil/list.jpg',
    },
    {
        name: 'Карточка товара',
        image: '/images/pic/teboil/card.jpg',
    },
    {
        name: 'Корзина',
        image: '/images/pic/teboil/cart.jpg',
    },
];
